import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { ADD_IMAGES, DELETE_IMAGES } from './constants';
import {
  AddImagesDataActionTypes,
  AddImagesError,
  AddImagesState,
  AddImagesSuccess,
} from './types';

const initialState: AddImagesState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (draft = initialState, action: AddImagesDataActionTypes): AddImagesState => {
    switch (action.type) {
      case ADD_IMAGES + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ADD_IMAGES + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AddImagesSuccess).payload;
        break;
      }
      case ADD_IMAGES + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AddImagesError).error;
        break;
      }
      case ADD_IMAGES + IDLE: {
        draft.status = idle;
        break;
      }
      case DELETE_IMAGES: {
        draft = initialState;
        return draft;
      }
      default:
        return draft;
    }
  },
);
